var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1029_22649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.34236 15.684C10.564 15.6837 11.7574 15.3546 12.8 14.7387C13.2351 14.4817 13.7993 14.5089 14.1566 14.8662L16.686 17.3954C17.0199 17.7293 17.5613 17.7293 17.8953 17.3954C18.2292 17.0614 18.2292 16.5199 17.8953 16.186L15.3662 13.657C15.0088 13.2997 14.9817 12.7353 15.2389 12.3002C15.8551 11.2574 16.1844 10.0639 16.1847 8.84199C16.1847 5.06949 13.1151 2 9.34236 2C5.56965 2 2.5 5.06949 2.5 8.84199C2.5 12.6145 5.56965 15.684 9.34236 15.684ZM9.34236 3.7105C12.1725 3.7105 14.4741 6.01197 14.4741 8.84199C14.4741 11.672 12.1725 13.9735 9.34236 13.9735C6.51219 13.9735 4.21059 11.672 4.21059 8.84199C4.21059 6.01197 6.51219 3.7105 9.34236 3.7105Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1029_22649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIcon);
export default __webpack_public_path__ + "static/media/InputIcon.6b03d1044de6864a972248a1885b1da9.svg";
export { ForwardRef as ReactComponent };